import { SVGProps } from 'react'

export const VisaBW = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="71"
      height="50"
      viewBox="0 0 71 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M30.2413 33.4177H26.2446L28.7444 17.6387H32.7409L30.2413 33.4177Z" fill="#6D6D6D" />
      <path
        d="M44.7277 18.0253C43.9394 17.706 42.6891 17.3535 41.143 17.3535C37.1962 17.3535 34.4168 19.502 34.3998 22.5738C34.367 24.8401 36.3897 26.0989 37.9025 26.8545C39.4488 27.6267 39.9744 28.1307 39.9744 28.819C39.9587 29.876 38.7249 30.3633 37.5743 30.3633C35.9786 30.3633 35.1236 30.1121 33.8243 29.524L33.298 29.2719L32.7388 32.8139C33.6761 33.2499 35.4032 33.6367 37.1962 33.6537C41.3898 33.6537 44.1199 31.5384 44.1523 28.265C44.1682 26.4688 43.1002 25.0924 40.7975 23.9677C39.3996 23.2458 38.5435 22.7589 38.5435 22.0202C38.5599 21.3487 39.2676 20.6608 40.8456 20.6608C42.1449 20.6272 43.0995 20.946 43.8227 21.265L44.1842 21.4326L44.7277 18.0253Z"
        fill="#6D6D6D"
      />
      <path
        d="M50.0424 27.8277C50.3716 26.9212 51.6381 23.4129 51.6381 23.4129C51.6215 23.4466 51.9666 22.4897 52.1639 21.9022L52.4432 23.2619C52.4432 23.2619 53.2001 27.0388 53.3644 27.8277C52.7398 27.8277 50.8318 27.8277 50.0424 27.8277ZM54.9758 17.6387H51.8844C50.9311 17.6387 50.2068 17.9238 49.7955 18.9479L43.8589 33.4174H48.0525C48.0525 33.4174 48.7429 31.4699 48.8913 31.0505C49.3514 31.0505 53.4309 31.0505 54.0227 31.0505C54.1375 31.6045 54.4996 33.4174 54.4996 33.4174H58.2001L54.9758 17.6387Z"
        fill="#6D6D6D"
      />
      <path
        d="M22.906 17.6387L18.992 28.3984L18.5643 26.2162C17.8406 23.6982 15.5712 20.9625 13.0386 19.6022L16.6237 33.4009H20.8501L27.1322 17.6387H22.906Z"
        fill="#6D6D6D"
      />
      <path
        d="M15.3574 17.6387H8.92711L8.86133 17.9575C13.8773 19.2671 17.1994 22.4237 18.5642 26.2179L17.1664 18.9652C16.9362 17.9573 16.229 17.6719 15.3574 17.6387Z"
        fill="#787878"
      />
    </svg>
  )
}
